import { type Cell, flexRender } from '@tanstack/react-table'
import type { CSSProperties } from 'react'

import { cn } from '@/utils'
import { HighlightText } from './HighlightText'
import type { TableData } from './types'

interface DataTableCellProps {
  cell: Cell<TableData, unknown>
}

const isEmpty = (value: unknown): boolean =>
  value === null || value === undefined || value === ''

export const DataTableCell = ({ cell }: DataTableCellProps) => {
  const { isFluid, wrap } = cell.column.columnDef.meta || {}
  const style = {
    '--column-size': `${cell.column.getSize()}px`,
  } as CSSProperties

  const hasCustomCell = cell.column.columnDef.cell !== undefined
  const searchQuery = cell.getContext().table.options.meta?.searchQuery

  return (
    <div
      key={cell.id}
      className={cn(
        'flex text-sm text-blue-6 px-2 first:pl-0 shrink-0 font-normal min-w-0',
        wrap
          ? 'items-start py-2 whitespace-normal break-words'
          : 'h-full items-center align-middle truncate',
        isFluid ? 'flex-1 w-auto' : 'w-(--column-size)',
      )}
      style={style}
    >
      {cell.column.columnDef.accessorKey && isEmpty(cell.getValue()) ? (
        <span aria-hidden="true" className="text-muted-foreground select-none">
          —
        </span>
      ) : hasCustomCell ? (
        flexRender(cell.column.columnDef.cell, cell.getContext())
      ) : (
        <HighlightText text={String(cell.getValue())} query={searchQuery} />
      )}
    </div>
  )
}
